import { useId } from 'react';
import { FieldDescription, FieldError, Input } from '@monksflow/monks-ui';
import { TypeIcon } from 'lucide-react';
import { KnowledgeBaseFormField } from '../KnowledgeBaseFormField';
import { KnowledgeBaseFormTitleProps } from './KnowledgeBaseFormTitle.types';
import { useTranslation } from 'react-i18next';

const MAX_LENGTH = 50;

export const KnowledgeBaseFormTitle = ({ title, setTitle, error }: KnowledgeBaseFormTitleProps) => {
  const { t } = useTranslation('knowledge');

  const fieldId = useId();
  const errorId = useId();
  const descriptionId = useId();
  const counterId = useId();

  return (
    <KnowledgeBaseFormField
      icon={<TypeIcon />}
      title={t('knowledgeBases.knowledgeBaseFormTitle.title')}
      description={t('knowledgeBases.knowledgeBaseFormTitle.giveAShortAndClear')}
      required={true}
      fieldId={fieldId}
      descriptionId={descriptionId}
    >
      <Input
        id={fieldId}
        placeholder={t('knowledgeBases.knowledgeBaseFormTitle.eGBrandIdentity')}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        maxLength={MAX_LENGTH}
        required
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${descriptionId} ${errorId}` : `${descriptionId} ${counterId}`}
      />
      {error ? (
        <FieldError id={errorId}>{error}</FieldError>
      ) : (
        <FieldDescription id={counterId}>
          {title.length}/{MAX_LENGTH}
        </FieldDescription>
      )}
    </KnowledgeBaseFormField>
  );
};

KnowledgeBaseFormTitle.displayName = 'KnowledgeBaseFormTitle';
